module.exports = __webpack_public_path__ + "7c9931251a73702691d8f4856b9e56a1.png";